var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.noninteractive.ds300",modifiers:{"hover":true,"noninteractive":true,"ds300":true}}],staticClass:"item-status-indicator",style:(_vm.style),attrs:{"title":_vm.hint}})}
var staticRenderFns = []

export { render, staticRenderFns }